import { combineReducers } from "redux";

import filters from "./filters";
import list from "./list";
import ui from "./ui";

export default combineReducers({
  filters,
  list,
  ui,
});
